import { render, staticRenderFns } from "./WelcomeGuide.vue?vue&type=template&id=1cb189b6"
import script from "./WelcomeGuide.vue?vue&type=script&lang=js"
export * from "./WelcomeGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports